// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2cEhC","inner":"Form_inner__300x-","range":"Form_range__nFnAR","name":"Form_name__1wwyB","actions":"Form_actions__1ZqtS"};